import getStars from '../../../utils/getStars';

const templateTrainingGroup = (hasOwner, slots, players) => slots.filter(item => item.nft_id).map((slot, index) => {
  const player = players.filter(player => player.name).find(item => item.id === slot.nft_id);
  return `
    <div class="swiper-slide player-detail d-flex align-items-start flex-column">
      <div class="player-detail__label d-flex align-items-center" for="player-${player?.id}">
        <img class="player-detail__image" src="${player?.thumbnail}" alt="${player?.name}" />
      </div>
      ${hasOwner ? `<div class="player-detail__countdown js-countdown" id="js-countdown-${index}" data-id="${player?.id}" data-start-date="${ slot.started_at}" data-end-date="${slot.end_date}"></div>` : ''}
      <div class="player-detail__content">
        <div class="player-detail__name">${getStars(player?.star)}</div>
        <div class="player-detail__name">${player?.name}</div>
        <div class="player-detail__id">#${player?.id}</div>
      </div>
    </div>
  `;
}).join('');

export default templateTrainingGroup;
